"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const retranslationsService = {
  getRetranslations: function () {
    return api.get("/RetranslationHosts", WithToken.headersToken({}, configuration.cookieName));
  },
  getRetranslationsTypes: function () {
    return api.get("/RetranslationHosts/Types", WithToken.headersToken({}, configuration.cookieName));
  },
  createRetranslation: function (options) {
    return api.post("/RetranslationHosts", options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteRetranslation: function (options) {
    return api.delete("/RetranslationHosts", WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  upddateRetranslation: function (options) {
    return api.put("/RetranslationHosts/" + options.id, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createRetranslationUnit: function (options) {
    return api.post("/UnitRetranslationHosts", options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteRetranslationUnit: function (options) {
    return api.delete("/UnitRetranslationHosts", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default retranslationsService;
